import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';
import CRMAccounts from '../crm/crm-accounts/crm.accounts';
import AutomationTriggers from './automation-triggers/AutomationTriggers';
import AutoDmComponent from './create-automation-trigger/AutoDmComponent';

const AutoDmInfoComponent = () => {
  const { t: translate } = useTranslation();
  const [currentTab, setCurrentTab] = useState('autodm');
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();

  const ACCOUNT_TABS = [
    {
      value: 'autodm',
      icon: <AccountBoxSharpIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <AutoDmComponent handleNavCRMAccounts={() => setCurrentTab('webhook-subscription-accounts')} />,
      label: translate('autodm_info.auto_dm', 'Auto Dm'),
    },
    {
      value: 'automationtriggers',
      icon: <ManageAccountsIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <AutomationTriggers isShowOfferBanner={isShowOfferBanner}/>,
      label: translate('autodm_info.automation_triggers', 'Automation Triggers'),
    },
    {
      value: 'webhook-subscription-accounts',
      icon: <ManageAccountsIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <CRMAccounts isShowOfferBanner={isShowOfferBanner}/>,
      label: translate('autodm_info.webhook_subscription_accounts', 'Webhook Subscription Accounts'),
    },
  ];
  return (
    <>
      <Helmet>
        <title>{translate('autodm_info.social_crm', 'Social CRM')}</title>
      </Helmet>
      <Tabs
        value={currentTab}
        scrollButtons="auto"
        variant="scrollable"
        sx={{ gap: '0.5rem', minHeight: '37px' }}
        allowScrollButtonsMobile
        onChange={(e, value) => setCurrentTab(value)}
      >
        {ACCOUNT_TABS.map((tab) => {
          return (
            <Tab
              sx={{
                flexDirection: 'row',
                gap: '0.25rem',
                padding: 0,
                minHeight: '10px',
                mr: '0.75rem',
                fontWeight: 600,
              }}
              disableRipple
              key={tab.value}
              label={tab.label}
              icon={tab.icon}
              value={tab.value}
            />
          );
        })}
        {(!isCustomDomain || isPortalAdmin) && (
          <Button
            variant="outlined"
            startIcon={<YouTubeIcon />}
            onClick={() => window.open('https://www.youtube.com/watch?v=_-GtdMkrMMk', '_blank')}
            color="primary"
          >
            {translate('common.tutorial')}
          </Button>
        )}
      </Tabs>
      <Box sx={{ mb: 2 }} />
      {ACCOUNT_TABS.map((tab) => {
        const isMatched = tab.value === currentTab;
        return isMatched && <Box key={tab.value}>{tab.component}</Box>;
      })}
    </>
  );
};
export default AutoDmInfoComponent;
